/* eslint-disable no-undef */
const EventBus = window.EventBus;
export const Omnisearch = {
  props: {
    results: Array,
    lang: String,
    templatedir: String,
    showvin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chosen: '',
      loading: false,
      selected: null,
      model: null,
      initialResultset: [],
      inputValue: '',
    }
  },
  created() {
    this.httpRequestInventory();
  },
  methods: {
    httpRequestInventory() {
      this.loading = true;
      //EventBus.httpRequestInventory(null, this.entryPoint, this.gutembergOptions);
      EventBus.getAllInventory(this.entryPoint);
    },
    entryPoint(inventory) {
      this.loading = false;
      this.initialResultset = this.format(inventory);
    },
    onRequestStart() {
      this.loading = true
    },
    goto(url) {
      window.open(url, '_self').focus();
    },
    onPress() {
      let rs = document.getElementsByClassName('result-button');
      if (rs && rs.length > 0) {
        let vm_button = document.querySelector('#result-button-link');
        vm_button.href = this.path + '/' + this.inputValue + '/';
        if (this.inputValue.length < 3 || this.$refs.suggestComponent.suggestions.length == 0) {
          document.body.removeChild(rs[0]);
        }
      }
      else {
        if (this.inputValue.length >= 3 && this.$refs.suggestComponent.suggestions.length > 0) {
          const element = document.querySelector('.suggestions');
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          var $suggestionsDiv = document.createElement('div');
          $suggestionsDiv.setAttribute('class', 'absolute result-button w-full flex justify-center p-4 bg-white shadow-md z-50');
          $suggestionsDiv.setAttribute('id', 'result-button');
          $suggestionsDiv.style.top = (offsetTop + offsetHeight + 92) + 'px';
          $suggestionsDiv.innerHTML = '<a href="' + this.path + this.inputValue + '/" class="p-4 bg-dark text-sm font-primary-bold text-white" id="result-button-link">View More Vehicles</a>';
          document.body.appendChild($suggestionsDiv);
        }
      }
    },
    onClick() {
      let rs = document.getElementsByClassName('result-button');
      if (rs && rs.length > 0) {
        return false;
      } else {
        const element = document.querySelector('.suggestions');
        const offsetTop = element.offsetTop;
        const offsetHeight = element.offsetHeight;

        var $suggestionsDiv = document.createElement('div');
        $suggestionsDiv.setAttribute('class', 'absolute result-button w-full flex justify-center p-4 bg-white shadow-md z-50');
        $suggestionsDiv.setAttribute('id', 'result-button');
        $suggestionsDiv.style.top = (offsetTop + offsetHeight + 92) + 'px';
        $suggestionsDiv.innerHTML = '<a href="' + this.path + this.inputValue + '/" class="p-4 bg-dark text-sm font-primary-bold text-white" id="result-button-link">View More Vehicles</a>';
        document.body.appendChild($suggestionsDiv);
      }
    },
    onClickOutside() {
      let rs = document.getElementsByClassName('result-button');
      if (rs && rs.length > 0) {
        if (this.inputValue.length >= 3) {
          document.body.removeChild(rs[0]);
        }
      }
    },
    onSuggestSelect() {
      if (this && this.model && this.model != null && this.model != undefined) {

        var itemSlug = this.path + this.model.replace(/ /g, '_').toLowerCase();
        this.initialResultset.forEach($item => {
          if ($item.title.split("Vin").length > 0) {
            if ($item.title.split("Vin")[1].indexOf(this.model) !== -1)
              itemSlug = $item.slug;
          }
        });

        if (this.$refs.suggestComponent.selected != null)
          itemSlug = this.$refs.suggestComponent.selected.slug;

        var payload = { 'event_category': 'LBX-SRP', 'event_label': ' LBX-' + this.model };
        window.sendGAEvent('LBX-Search', payload);
        // similar behavior as clicking on a link
        jQuery("#search").attr("disabled", "disabled");

        var jlr_script = document.getElementById("shiftdigital-script");

        if (jlr_script != null) {
          sd('dataLayer', {
            typedSearchContent: this.model.replaceAll(" ", "|"),
            events: 'typedSearch'
          });
          sd('send');
        }

        window.location.href = itemSlug;
      }
    },
    onRequestDone() {
      this.loading = false
    },
    onRequestFailed() {
      this.loading = false
    },
    customFilter(el, value) {
      //console.log(el.title);
      //console.log(value);

      var text = el.title;
      var searchWords = (value && value.length > 0) ? value.trim().split(' ') : [];
      var total = 0;
      //console.log('INIT TOTAL FOUND: ' + total + ' TOTAL ARRAY: ' + searchWords.length);
      //|| (vehicle.model.toLowerCase().split(' ').join('').indexOf(model.toLowerCase().split(' ').join('')) !== -1)
      // || (vehicle.model.toLowerCase().split('-').join('').indexOf(model.toLowerCase().split('-').join('')) !== -1)
      for (var j = 0; j <= searchWords.length; j++) {
        if (text && searchWords && searchWords[j] &&
          (text.toLowerCase().indexOf(searchWords[j].toLowerCase()) !== -1
            || text.toLowerCase().split(' ').join('').indexOf(searchWords[j].toLowerCase().split(' ').join('')) !== -1
            || text.toLowerCase().split('-').join('').indexOf(searchWords[j].toLowerCase().split('-').join('')) !== -1
          )
        )
          total++;
      }

      //console.log('TOTAL FOUND: ' + total + ' TOTAL ARRAY: ' + searchWords.length);
      if (total == searchWords.length) {
        return true;
      }
      else {
        return false;
      }

    },
    onSuggestClick(suggest) {
      //alert( "VALUE SELECTED: " + suggest);
      var payload = { 'event_category': 'LBX-SRP', 'event_label': ' LBX-' + suggest };
      window.sendGAEvent('LBX-Search', payload);

      // similar behavior as clicking on a link
      window.location.href = this.path + suggest.replace(/ /g, '_').toLowerCase();
    },
    simpleSuggestionList() {
      return this.initialResultset;
    },
    format(list) {
      var $filtered = [];
      list.forEach($item => {
        var $text;
        if (this.lang == 'fr_CA') {
          $text = (($item.make) ? $item.make + ' ' : '') +
            (($item.model) ? $item.model + ' ' : '') +
            (($item.productline) ? $item.productline + ' ' : '') +
            (($item.trim) ? $item.trim + ' ' : '') +
            (($item.year) ? $item.year + ' ' : '') +
            (($item.condition) ? this.$t($item.condition) + ' ' : '') +
            (($item.stocknumber) ? ' Stock #' + $item.stocknumber : '') +
            (this.showvin ? (($item.vin) ? ' Vin #' + $item.vin : '') : '');
        } else {
          $text = (($item.condition) ? this.$t($item.condition) + ' ' : '') +
            (($item.year) ? $item.year + ' ' : '') +
            (($item.make) ? $item.make + ' ' : '') +
            (($item.model) ? $item.model + ' ' : '') +
            (($item.productline) ? $item.productline + ' ' : '') +
            (($item.trim) ? $item.trim + ' ' : '') +
            (($item.stocknumber) ? ' Stock #' + $item.stocknumber : '') +
            (this.showvin ? (($item.vin) ? ' Vin #' + $item.vin : '') : '');
        }

        if ($item.picture && $item.picture.includes("-XXL"))
          $item.picture = $item.picture.replace(/-XXL/g, "-card.jpg").replace('http:', 'https:');

        $filtered.push({
          id: $item.id,
          condition: $item.condition,
          year: $item.year,
          make: $item.make,
          model: $item.model,
          bodystyle: $item.bodystyle,
          exteriorcolor: $item.exteriorcolor,
          transmission: $item.transmission,
          mileage: $item.mileage,
          title: $text,
          name: (($item.year) ? $item.year + ' ' : '') + (($item.make) ? $item.make + ' ' : '') + (($item.model) ? $item.model + ' ' : '') + (($item.trim) ? $item.trim + ' ' : ''),
          vin: $item.vin,
          trim: $item.trim,
          stocknumber: $item.stocknumber,
          slug: this.viewSlug($item),
          picture: $item.picture,
          price: $item.price
        })
      });
      return $filtered;
    },
    viewSlug(item) {
      let slug = "/view/";
      if (this.lang == 'fr_CA')
        slug = "/vue/";

      return slug +
        item.condition.toLowerCase().replace(/ /g, "-") + "-" +
        item.year.toLowerCase().replace(/ /g, "-") + "-" +
        item.make.toLowerCase().replace(/ /g, "-") + "-" +
        item.model.toLowerCase().replace(/ /g, "-") + "-" +
        item.id;
    },
    imgLoadOnError(id) {
      if (id) {
        for (let i = 0; i < this.$refs[id + "omnisearch-main-img"].length; i++) {
          this.$refs[id + "omnisearch-main-img"][i].src = this.templatedir;
        }
      }
      this.picture = this.templatedir;
    },
  },
  computed: {
    path() {
      if (this.lang == 'fr_CA')
        return '/recherche/filter/';
      else
        return '/search/filter/';
    },
    gutembergOptions() {
      return { "year": "all", "make": "all", "model": "all", "trim": "all", "price": "all", "mileage": "all", "type": "all", "status": "all", "tags": "all", "stock": "all", "filter": true, "limit": "0", "sort_by": "year", "sort_by_condition": "desc", "flags": "none", "layout": "normal", "location": "all" }
    }
  },
}
